import type { ReactNode } from "react";
import React from "react";

import type { ToggleDrawer } from "@braintrust/braintrust-ui-components";
import {
  Box,
  TileButton,
  Typography,
} from "@braintrust/braintrust-ui-components";
import { SettingsRoundedIcon } from "@braintrust/braintrust-ui-components/Icons";
import { ChangesSavedMarker } from "@js/apps/jobs/apps/create-job/components/changes-saved-marker";

import style from "./style.module.scss";

type RequirementCardProps = {
  label: string;
  detail: string;
  icon?: ReactNode;
  toggleDrawer: ToggleDrawer;
  type: "locations" | "timezones";
};

export const RequirementCard = ({
  label,
  detail,
  icon,
  toggleDrawer,
  type,
}: RequirementCardProps) => {
  return (
    <TileButton
      variant="white-violet"
      shape="squared"
      className={style.requirementCardButton}
      onClick={toggleDrawer}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box
              sx={{
                width: 41,
                minWidth: 41,
                height: 41,
                minHeight: 41,
                bgcolor: "rgba(229, 236, 236, 07)",
                display: "grid",
                borderRadius: 20,
                placeItems: "center",
                mr: 2,
                alignContent: "center",
                justifyContent: "center",
              }}
            >
              {icon}
            </Box>
            <Box sx={{ textAlign: "left" }}>
              <Typography component="p" variant="label" size="small">
                {label}
              </Typography>
              <Typography
                component="p"
                variant="label"
                size="large"
                multilineEllipsis={2}
              >
                {detail}
              </Typography>
            </Box>
          </Box>
          <Box
            sx={{
              display: "grid",
              placeItems: "center",
              gridAutoFlow: "column",
            }}
          >
            <ChangesSavedMarker variant="minimal" sections={[type]} />
            <SettingsRoundedIcon sx={{ ml: 1 }} />
          </Box>
        </Box>
      </Box>
    </TileButton>
  );
};
